import React, { forwardRef } from 'react'
import PropTypes from 'prop-types'
import { Row, Form, Checkbox, Input } from 'antd'
import { connect } from 'react-redux'
import { isEmpty } from 'lodash'

// Components
import EditableTable from "../../Table/EditableTable";
import Api_tnn from "../../../api/api.tnn";
import Message from "../../Messages";
import EditorCheckbox from "../../DataGrid/EditorCheckbox";
import UnClickableCheckbox from "../../Common/Checkbox/UnClickableCheckBox";
import EditorNumberField from "../../DataGrid/EditorNumberField";
import DataGrid from "../../DataGrid";
import helper from '../../../helper/helper'
import Table from "../../Table";
import InputNumber from "../../Common/NumberField"
// import Input from "../../Common/Input"

// Columns
const columnDetail = ({ } = {}) => [
  {
    title: "#",
    dataIndex: "stt",
    width: "65px",
  },
  {
    title: "Quan trắc tự động",
    dataIndex: "qT_TuDong",
    width: 100,
    render: (value, row) =>
      <div style={{ textAlign: "center" }}>
        <Checkbox defaultChecked={row.qT_TuDong} disabled={true} />
      </div>
  },
  {
    title: "Thông số",
    dataIndex: "tenThongSo",
  },
  {
    title: "Đơn vị",
    dataIndex: "tenDonVi",
    width: 150,
  },
  {
    title: "Gía trị giới hạn nhỏ nhất",
    dataIndex: "gioiHanMin",
    width: 120,
    render: (value, row) =>
      <div>{value ? value : 0}</div>
  },
  {
    title: "Gía trị giới hạn lớn nhất",
    dataIndex: "gioiHanMax",
    width: 120,
    render: (value, row) =>
      <div>{value ? value : 0}</div>
  },
]
const column = ({ } = {}) => [
  {
    title: "#",
    dataIndex: "stt",
    width: "65px",
  },
  {
    title: "Quan trắc tự động",
    dataIndex: "qT_TuDong",
    width: 100,
    render: (value, row) =>
      <div style={{ textAlign: "center" }}>
        <Checkbox defaultChecked={row.qT_TuDong} onChange={value => { row.qT_TuDong = value.target.checked }} />
      </div>
  },
  {
    title: "Thông số",
    dataIndex: "tenThongSo",
    render: (value, row) =>
      <div>
        {row.tenThongSo === "" ?
          <Input
            mandatory={false}
            width="100%"
            defaultValue={row.tenThongSo}
            onChange={value => row.tenThongSo = value.target.value}
            style={{ border: "#fff" }}
          /> : <div>{row.tenThongSo}</div>}
      </div>
  },
  {
    title: "Đơn vị",
    dataIndex: "tenDonVi",
    width: 150,
    render: (value, row) =>
      <div>
        {row.tenDonVi === "" ?
          <Input
            mandatory={false}
            width="100%"
            defaultValue={row.tenDonVi}
            onChange={value => row.tenDonVi = value.target.value}
            style={{ border: "#fff" }}
          /> : <div>{row.tenDonVi}</div>}
      </div>
  },
  {
    title: "Gía trị giới hạn nhỏ nhất",
    dataIndex: "gioiHanMin",
    width: 120,
    render: (value, row) =>
      <div>
        <InputNumber
          mandatory={false}
          width="100%"
          defaultValue={value ? value : 0}
          onChange={value => row.gioiHanMin = value}
        />
      </div>,
  },
  {
    title: "Gía trị giới hạn lớn nhất",
    dataIndex: "gioiHanMax",
    width: 120,
    render: (value, row) =>
      <div>
        <InputNumber
          mandatory={false}
          width="100%"
          defaultValue={value ? value : 0}
          onChange={value => row.gioiHanMax = value}
        />
      </div>,
  },
];

class GioiHanThongSo extends React.Component {
  constructor() {
    super();
    this.state = {
      dataSource: []
    }
  }

  componentDidMount() {
    this.get_CauHinhThongSo()
  }

  handleUpdateDataSource = (newData) => {
    this.setState({ dataSource: newData })
  };

  getDataSource = () => {
    return this.state.dataSource
  };

  get_CauHinhThongSo = () => {
    const { user, quyChuanApDung } = this.props;
    if (quyChuanApDung) {
      new Api_tnn().get_CauHinhThongSo_Init({
        token: user.access_token,
        id_qcvn: quyChuanApDung
      })
        .then(res => {
          this.setState({ dataSource: res.list_gioihan_thongso && res.list_gioihan_thongso.map((item, index) => ({ ...item, stt: index + 1 })) })
        })
        .catch(err => Message.error(err.message))
    } else {
      this.setState({ dataSource: [] })
    }
  };

  componentDidUpdate(prevProps, prevState, snapshot) {
    const { initialValue, quyChuanApDung, mode } = this.props;
    if (prevProps.initialValue !== this.props.initialValue && initialValue !== undefined && initialValue.length > 0) {
      {
        mode === "presentation" ?
          this.setState({ dataSource: initialValue.filter(value => value.tenThongSo !== "").map((item, index) => ({ ...item, stt: index + 1 })) })
          :
          this.setState({ dataSource: initialValue.map((item, index) => ({ ...item, stt: index + 1 })) })
      }
    }
    else if (prevProps.quyChuanApDung !== quyChuanApDung) {
      this.get_CauHinhThongSo()
    }
  }

  render() {
    const { mode } = this.props;
    const { dataSource } = this.state;
    return (
      <Row>
        <Table
          columns={mode !== "presentation" ? column({}) : columnDetail({})}
          dataSource={dataSource}
          pagination={false}
          scroll = {{y: 400}}
        />
      </Row>
    )
  }
}

GioiHanThongSo.propTypes = {
  initialValue: PropTypes.object,
  mode: PropTypes.string.isRequired,
  quyChuanApDung: PropTypes.number.isRequired,
};

const mapStateToProps = (state) => ({
  user: state.oidc.user
});

export default connect(mapStateToProps, null, null, { forwardRef: true })(GioiHanThongSo)
